import TableOfContents from '@/components/TableOfContents/TableOfContents';

interface MenuItem {
  text: string;
  anchor: string;
}

interface TableOfContentsProps {
  title: string;
  menuItems: MenuItem[];
}

export default function TableOfContentsBuilder({ title, menuItems }: TableOfContentsProps) {
  return (
    <TableOfContents
      title={title}
      menuItems={menuItems}
      backgroundColor="tw-bg-color-cream-light"
      textColor="tw-text-black"
    />
  );
}
